import script from "./IndexPage.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexPage.vue?vue&type=script&setup=true&lang=js"

import "./IndexPage.vue?vue&type=style&index=0&id=22a96d6d&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.30_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22a96d6d"]])

export default __exports__